import axios from 'axios'
import {KTIcon} from '../../../../_metronic/helpers'
import {BASE_URL} from '../../config'
import {useSenderIdProvider} from '../context/SenderIdProvider'
import toast from 'react-hot-toast'

const DOWNLOAD_SENDER_URL = `${BASE_URL}/api/protect/downloadSenderList`

/* eslint-disable jsx-a11y/anchor-is-valid */
const DownloadButton = () => {
  const {downloadSenderIds} = useSenderIdProvider()

  const downloadAllSender = async () => {
    try {
      toast.loading('Processing..')
      const response = await axios.get(DOWNLOAD_SENDER_URL, {
        responseType: 'text',
      })

      // TODO: Need to format time
      // console.log(response.data)

      // Assume response.data is CSV string
      const rawCsv = response.data
      // Split lines
      const lines = rawCsv.split('\n')

      // Remove ID column from each line
      const newCsv = lines
        .map((line: string) => {
          if (!line.trim()) return '' // skip empty lines
          const cols = line.split(',')
          cols.shift() // remove first column (ID)
          return cols.join(',')
        })
        .join('\n')

      // Create blob with updated CSV
      const blob = new Blob([newCsv], {type: 'text/csv;charset=utf-8;'})
      console.log(newCsv)
      const url = URL.createObjectURL(blob)

      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'sender_ids.csv')
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)

      toast.dismiss()
      toast.success('There you go')
    } catch (error) {
      toast.dismiss()
      toast.error('Something went wrong')
      console.log(error)
    }
  }

  return (
    <div className='dropdown d-inline'>
      <button
        className='btn btn-success dropdown-toggle'
        type='button'
        id='dropdownMenuButton1'
        data-bs-toggle='dropdown'
        aria-expanded='false'
      >
        <KTIcon iconName='cloud-download' className='fs-2' />
        Download
      </button>
      <ul className='dropdown-menu w-150px mt-5' aria-labelledby='dropdownMenuButton1'>
        <li>
          <a className='dropdown-item fs-4 ps-6' href='#' onClick={downloadSenderIds}>
            Current Page
          </a>
        </li>
        <li>
          <a className='dropdown-item fs-4 ps-6' href='#' onClick={downloadAllSender}>
            All
          </a>
        </li>
      </ul>
    </div>
  )
}

export default DownloadButton
